// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_type_b/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_type_b: ModuleSchema = {
  "id": "core_rattan_type_b",
  "uniqueId": "B3D_RTB01",
  "createdAt": "2026-10-26T06:34:25.183Z",
  "updatedAt": "2026-10-27T08:51:40.679Z",
  "label": "Rattan Type B",
  "description": "One-layer Type B wall-backed rattan texture with a 3 mm base pad.",
  "category": "rattan",
  "tags": [
    "core-rattan-type-b"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Form Width",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Form Depth",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Form Height",
      "min": 12,
      "max": 120,
      "default": 40,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 4,
      "max": 24,
      "default": 6,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0.5,
      "max": 5,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "faceCycles",
      "label": "Odd Cycles Per Face",
      "min": 3,
      "max": 15,
      "default": 7,
      "step": 2,
      "unit": "cycles",
      "enabled": true,
      "visible": true
    },
    {
      "key": "layerOverlap",
      "label": "Texture Layer Overlap",
      "min": 0,
      "max": 1.6,
      "default": 0,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.2,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.4,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "padThickness",
      "label": "Structural Pad Thickness",
      "min": 0.2,
      "max": 10,
      "default": 3,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableBottomWatermark",
      "label": "Bottom Brand Watermark (Z=0)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableCavityWatermark",
      "label": "Anti-Theft Surface Brand Watermark",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "wave_form",
      "label": "Form and Woven Surface",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "label": "Core Rattan Type B",
      "name": "Core Rattan Type B",
      "color": "#64748b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "wave_form",
          "label": "Form and Woven Surface",
          "name": "Form and Woven Surface",
          "groupId": 0,
          "colorKey": "wave_form",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
